const SELECT_CONTENT_DISPOSITION_CONSTANTS = {
  TAKEAWAY: 'PICKUP',
  ORDER_TYPE_STORE_INFO_FROM: 'from',
  ORDER_TYPE_STORE_INFO_TO: 'to',
  ORDER_TYPE_STORE_INFO_AT: 'at',
  HOMEPATH: '',
  HOMEPATHSELECT: '/',
};

export const OUT_OF_SERVICE = 'outOfService';
export const CLOSED = 'CLOSED';

export default SELECT_CONTENT_DISPOSITION_CONSTANTS;
